import { BaseSlice } from '../../components/BaseSlice';
import { Bounded } from '../../components/Bounded';
import { RichText } from '../../components/RichText';
import ProjectTimelineComponent from '../../components/ProjectCalendar';

/**
 * @typedef {import("@prismicio/client").Content.ProjectTimelineSlice} ProjectTimelineSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectTimelineSlice>} ProjectTimelineProps
 * @param {ProjectTimelineProps}
 */
const ProjectTimeline = ({ slice, context }) => {
  const page = context;
  if (page.type !== 'project') return null;
  return (
    <Bounded as="section">
      <BaseSlice>
        <div className="mb-5">
          <RichText field={slice.primary?.text} />
        </div>

        <ProjectTimelineComponent projects={[page]} hideName />
      </BaseSlice>
    </Bounded>
  );
};

export default ProjectTimeline;
